<template>
  <div class="orderFormPage">
    <!-- header start -->
    <van-nav-bar
      title="订单结算"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <section class="form-panel">
        <router-link :to="{path:'/BookingGoodsDetails',query:{puid:productApiModel.ProductId, notShow:true}}" class="book-goods-list">
          <div class="hd">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="productApiModel.CoverPhoto"
            />
          </div>
          <div class="bd">
            <h2 class="title">{{productApiModel.ProductName}}</h2>
            <div class="price">￥{{productApiModel.Price}}</div>
          </div>
        </router-link>
      </section>

      <section class="form-panel">
        <van-cell title="数量">
          <template #right-icon>
            <van-stepper v-model="stepValue" />
          </template>
        </van-cell>
      </section>

      <section class="form-panel">
        <div class="order-info-item">
          <div class="label-tit">
            预约时间
            <span class="selectBtn" @click="bookDateShow = true">选择日期</span>
          </div>
          <van-field placeholder readonly v-model="bookDate" />
        </div>
        <div class="order-info-item">
          <div class="label-tit">
            <i class="require">*</i>委托人姓名
          </div>
          <van-field placeholder="填写委托人姓名" />
        </div>
        <div class="order-info-item">
          <div class="label-tit">
            <i class="require">*</i>委托人证件号码
          </div>
          <van-field placeholder="身份证/回乡证" />
        </div>
        <div class="order-info-item">
          <div class="label-tit">
            <i class="require">*</i>手机
          </div>
          <van-field placeholder="请输入手机号码" type="tel" />
        </div>
        <div class="order-info-item">
          <div class="label-tit">
            <i class="require">*</i>先人姓名
          </div>
          <van-field placeholder="请填写先人姓名" />
        </div>
        <div class="order-info-item">
          <div class="label-tit">
            <i class="require">*</i>安葬地点
            <span class="selectBtn" @click="arealistShow = true;">{{areaListInput}}</span>
          </div>
          <div class="muyuanBox">
            <van-radio-group v-model="muyuanRadio" v-for="item in cemeteryList" :key="item.SerialNumber"  >
              <van-cell :border="false" :title="item.CemeteryName" clickable @click="muyuanRadio = item.SerialNumber">
                <template #right-icon>
                  <van-radio :name="item.SerialNumber" />
                </template>
              </van-cell>
              <!-- <van-cell :border="false" title="仙峰山墓园" clickable @click="muyuanRadio = '2'">
                <template #right-icon>
                  <van-radio name="2" />
                </template>
              </van-cell>
              <van-cell :border="false" title="仙峰山骨灰室" clickable @click="muyuanRadio = '3'">
                <template #right-icon>
                  <van-radio name="3" />
                </template>
              </van-cell> -->
            </van-radio-group>
          </div>
        </div>
        <div class="order-info-item">
          <div class="label-tit">
            <i class="require">*</i>安放位置
          </div>
          <van-field placeholder="**墓园**区**行**号、**骨灰室 **室**柜**行**号" />
        </div>

        <div class="order-info-item">
          <div class="label-tit">
            <i class="require"></i>上传寄存证/安葬证封面
          </div>
          <div class="van-cell">
            <van-uploader :after-read="afterRead" v-model="fileList" :max-count="1" />
          </div>
        </div>
        <div class="order-info-item">
          <div class="label-tit">
            <i class="require"></i>上传寄存证/安葬证信息页
          </div>
          <div class="van-cell">
            <van-uploader :after-read="afterRead" v-model="fileList" :max-count="1" />
          </div>
        </div>
      </section>

      <section class="form__bottom van-hairline--top">
        <div class="total-price">￥{{Math.floor((productApiModel.Price * stepValue) * 100) / 100}}</div>
        <div class="flexmid">
          <van-button round color="orange" size="large" to="/BookingForm" replace>提交订单</van-button>
        </div>
      </section>
    </div>

    <!-- 预约时间 popup start -->
    <van-popup v-model="bookDateShow" position="bottom">
      <van-datetime-picker
        show-toolbar
        title="请选择预约时间"
        v-model="currenDate"
        type="date"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="bookDateShow = false"
        @cancel="bookDateShow = false"
        @change="bookDateChange"
      />
    </van-popup>
    <!-- 预约时间 popup end -->

    <!-- 选择省 / 市 / 区 popup start -->
    <van-popup v-model="arealistShow" position="bottom">
      <!-- <van-area
        :area-list="areaList"
        :columns-num="2"
        value="110101"
        @confirm="arealistShow = false"
        @cancel="arealistShow = false"
        @change="onAreaListChange"
      /> -->
      <van-picker ref="area"
        show-toolbar	
        :columns="columns"
        :default-index="0"
        @cancel="arealistShow = false"
        @confirm="onConfirm"
        
      />
    </van-popup>
    <!-- 选择省 / 市 / 区 popup end -->
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import AreaList from "@/assets/js/area";
export default {
  data() {
    return {
      stepValue: 1,
      muyuanRadio: 0,
      fileList: [],
      currenDate: new Date(),
      bookDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      bookDateShow: false,
      minDate: new Date(),
      maxDate: new Date(new Date().getFullYear() + 2, 10, 1),
      arealistShow: false,
      areaList: AreaList,
      areaListInput: "选择安葬地点",
      productApiModel : {},
      columns:[],
      cemeteryList:[{SerialNumber : 0,CemeteryName:"请选择墓园"}],
    };
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2 !important");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      //console.log(file);
    },
    bookDateChange(picker, value, index) {
      var dateArray = picker.getValues();
      this.bookDate = dateArray.join("-");
    },
    /*选择省 / 市 / 区*/
    // onAreaListChange(picker, values,  ){
    //   var v = this.$refs.area.getIndexes()
    //   var areaValue = picker.getValues();
    //   this.areaListInput = areaValue[0] +' / '+ areaValue[1]
    // },
    onConfirm(value) {
      this.arealistShow = false;
      this.areaListInput = value[0] +' / '+ value[1]
      this.getCemeteryList();
    },
    init(){
      var that = this;
      that.$store.dispatch({
        type:"GetSharedGetAreasList",
      }).then(res => {
        //console.log(res);
        if(res.AreasList){
          for(var i=0; i< res.AreasList.length; i++){
            // 加载市区
            var temp = {
              id : res.AreasList[i].ID,
              text : res.AreasList[i].DescName,
              children:[],
            };
            // 加载城市
            res.AreasList[i].CityList.map(ce => {
              temp.children.push({
                id : ce.ID,
                text : ce.DescName
              })
            })
            that.columns.push(temp);
          }      
        }
      }, err => {})
    },
    getCemeteryList(){
      var that = this;
      var Indexes = this.$refs.area.getIndexes();
      var areaLastId = this.columns[Indexes[0]].children[Indexes[1]].id;
      this.$store.dispatch({
        type: "GetCemeteryApiModelSearchList",
        AreaLastId : areaLastId,
      }).then(res => {
        //console.log(res.CemeteryApiModelList);
        if(res.CemeteryApiModelList.length > 0){
          that.cemeteryList = res.CemeteryApiModelList;
          that.muyuanRadio = res.CemeteryApiModelList[0].SerialNumber;
        }else{
          that.muyuanRadio = 0;
          that.cemeteryList = [{SerialNumber : 0,CemeteryName:"暂无墓园"}];
        }
        
      }, err =>{});
    }
  },
  created() {
    this.productApiModel = this.$store.state.productApiModel;
    this.init();
  }
};
</script>

<style scoped>
.book-goods-list {
  background-color: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 14px 16px;
}
.book-goods-list > .hd {
  width: 80px;
  height: 80px;
  margin-right: 12px;
}
.book-goods-list > .hd > .avatar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}
.book-goods-list > .bd {
  flex: 1;
  overflow: hidden;
}
.book-goods-list > .bd .title {
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.book-goods-list > .bd .price {
  overflow: hidden;
  font-size: 14px;
  color: crimson;
  margin-top: 20px;
}
.form-panel {
  margin-bottom: 8px;
  background-color: #fff;
}
.label-tit {
  padding: 0 16px;
  font-size: 13px;
  color: #555;
}
.selectBtn {
  color: #1989fa;
  margin-left: 20px;
}
.label-tit .require {
  color: red;
  margin-right: 6px;
}
.order-info-item {
  border-bottom: 1px solid #eee;
  background-color: #fff;
  padding: 16px 0 4px;
}
.muyuanBox {
  padding: 10px;
}
.form__bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 0 16px;
}
.orderFormPage {
  padding-bottom: 50px;
}
.form__bottom .total-price {
  font-size: 21px;
  color: crimson;
  width: 120px;
  margin-right: 10px;
}
.form__bottom .van-button {
  height: 40px;
  line-height: 40px;
}
</style>
